<template>
  <v-dialog persistent v-model="openDeleteCommentModel" max-width="400">
    <v-card class="px-4 pt-2 pb-4" v-if="commentForDelete">
      <div class="px-3 pt-3 mb-n3 d-flex justify-end">
        <v-icon class="cursor-pointer" @click="closeDeleteCommentModel()"
          >mdi-close</v-icon
        >
      </div>
      <div class="d-flex justify-center mb-4 mt-6">
        {{ lang.profile.w7 }}
        {{
          commentForDelete.type == "comment"
            ? lang.profile.comment
            : lang.profile.thread
        }}?
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          small
          text
          @click="closeDeleteCommentModel()"
          elevation="0"
        >
          {{ lang.actions.close }}
        </v-btn>
        <v-btn small class="btn-bg" elevation="0" @click="deleteComment()">
          {{ lang.actions.delete }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteCommentDialog",
  props: {
    commentForDelete: {
      type: Object,
      default: null,
    },
    openDeleteCommentModel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  methods: {
    closeDeleteCommentModel() {
      this.$emit("closeDeleteCommentModel");
    },
    deleteComment() {
      this.$emit("deleteComment");
    },
  },
};
</script>

